import { Routes } from "@angular/router";

export const redirects: Routes = [
  // Legacy edit/:id → :id/edit (must precede the prefix redirect below)
  {
    path: ':locale/pdc/:tenant_id/documents/:queue/edit/:document_id',
    pathMatch: 'full',
    redirectTo: ':locale/pdc/:tenant_id/validation/:queue/:document_id/edit'
  },
  // documents/:queue/list → validation/:queue (must precede the generic /list rule below)
  {
    path: ':locale/pdc/:tenant_id/documents/:queue/list',
    pathMatch: 'full',
    redirectTo: ':locale/pdc/:tenant_id/validation/:queue'
  },
  // All other documents/* → validation/* (prefix appends remaining segments)
  {
    path: ':locale/pdc/:tenant_id/documents',
    pathMatch: 'prefix',
    redirectTo: ':locale/pdc/:tenant_id/validation'
  },
  // Strip /list suffix from any section/resource (configuration, api, reports, …)
  {
    path: ':locale/pdc/:tenant_id/:section/:resource/list',
    pathMatch: 'full',
    redirectTo: ':locale/pdc/:tenant_id/:section/:resource'
  },
];
